import React from 'react'
import { useTranslation } from 'react-i18next'

import { PhotoSelector } from '@/components/PhotoSelector/PhotoSelector'
import { Separator } from '@/components/ui/separator'
import type { TPlan } from '@/store/api/Users/Users.types'

interface UserCardProps {
  plan: TPlan | null
  profileImgUrl: string
  fullname: string
  credits: number
  impersonationCredits?: number
}

export const UserCard = ({
  plan,
  profileImgUrl,
  fullname,
  credits,
  impersonationCredits = 0,
}: UserCardProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-5 w-1/2 bg-baseColorHighlight rounded-2xl p-4 max-md:w-full max-lg:w-3/4">
      <PhotoSelector
        plan={plan}
        initialImageUrl={profileImgUrl}
        fullname={fullname}
      />
      <Separator className="bg-neutralColor30 h-[0.5px]" />

      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-1">
          <p className="text-xl font-medium text-neutralColor">
            {credits ?? 0}
          </p>
          <p className="text-sm font-normal text-neutralColor60">
            {t('dashboard.home.userCard.autocheckCredits')}
          </p>
        </div>

        <div className="flex flex-col gap-1 text-right">
          <p className="text-xl font-medium text-neutralColor">
            {impersonationCredits ?? 0}
          </p>
          <p className="text-sm font-normal text-neutralColor60">
            {t('dashboard.home.userCard.impersonationCredits')}
          </p>
        </div>
      </div>
    </div>
  )
}
